<template>
  <div>
    <a-modal
      width="1000px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="订单发货"
      @ok="handleSubmit"
    >
      <a-row>
        <a-col :span="8">
          <a-descriptions title="基本信息" :column="1">
            <a-descriptions-item label="客户名称">
              {{ data.agent_name }}
            </a-descriptions-item>

            <a-descriptions-item label="订单编号">
              {{ data.order_no }}
            </a-descriptions-item>

            <a-descriptions-item label="项目数量">
              {{ data.items_count }}
            </a-descriptions-item>

            <a-descriptions-item label="订单状态">
              {{ data.status }}
            </a-descriptions-item>

            <a-descriptions-item label="创建时间">
              {{ data.created_at }}
            </a-descriptions-item>

            <a-descriptions-item label="订单备注">
              {{ data.remark }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="8">
          <a-descriptions title="订单金额" :column="1">
            <a-descriptions-item label="总卡数(张)">
              {{ data.card_count }}
            </a-descriptions-item>

            <a-descriptions-item label="订单金额(元)">
              {{ data.order_fee | formatFloat }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="8">
          <a-descriptions title="收货信息" :column="1">
            <a-descriptions-item label="收货方式">
              {{ data.pickup_way }}
            </a-descriptions-item>

            <a-descriptions-item label="收货人" v-if="data.pickup_way_slug === 'post'">
              {{ data.receiver }}
            </a-descriptions-item>

            <a-descriptions-item label="联系方式" v-if="data.pickup_way_slug === 'post'">
              {{ data.phone_number }}
            </a-descriptions-item>

            <a-descriptions-item label="所属地区" v-if="data.pickup_way_slug === 'post'">
              {{ data.region }}
            </a-descriptions-item>

            <a-descriptions-item label="地区邮编" v-if="data.pickup_way_slug === 'post'">
              {{ data.post_code }}
            </a-descriptions-item>

            <a-descriptions-item label="详细地址">
              {{ data.address_detail }}
              <a-tooltip>
                <template slot="title">
                  点击复制
                </template>
                <a-icon
                  class="simiot-cursor-pointer"
                  type="copy"
                  theme="twoTone"
                  v-clipboard:copy="copyAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                />
              </a-tooltip>
            </a-descriptions-item>

          </a-descriptions>
        </a-col>
      </a-row>

      <a-row>
        <a-divider />
        <a-descriptions title="发货信息" :column="1" />

        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 9 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-row :gutter="24" v-if="data.pickup_way_slug === 'post'">
            <a-col :span="8">
              <a-form-item label="寄件地址">
                <a-input
                  v-decorator="['sender_address', {
                    normalize: this.$lodash.trim,
                    rules: [
                      { required: true, message: '请输入寄件地址' }
                    ]
                  }]"
                  :read-only="true"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="寄件人">
                <a-input
                  v-decorator="['sender_name', {
                    normalize: this.$lodash.trim,
                    rules: [
                      { required: true, message: '请输入寄件人' }
                    ]
                  }]"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="寄件电话">
                <a-input
                  v-decorator="['sender_phone', {
                    normalize: this.$lodash.trim,
                    rules: [
                      { required: true, message: '请输入寄件电话' },
                      { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确' }
                    ]
                  }]"
                  placeholder="11位手机号"
                  maxlength="11"
                  allow-clear
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24" v-if="data.pickup_way_slug === 'post'">
            <a-col :span="8">
              <a-form-item label="快递公司">
                <a-select
                  :loading="loadingExpressCompanyOptions"
                  @focus="fetchExpressCompanyOptions"
                  @change="handleExpressCompanyChange"
                  v-decorator="['express_company', {
                    rules: [{ required: true, message: '请选择快递公司' }]
                  }]"
                  allow-clear
                >
                  <a-select-option
                    v-for="company in expressCompanyOptions"
                    :key="company.value"
                    :value="company.value"
                  >
                    {{ company.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="取件时间">
                <a-date-picker
                  style="width: 100%;"
                  :show-time="{ format: 'HH:mm' }"
                  format="YYYY-MM-DD HH:mm"
                  v-decorator="['delivery_time', {
                    rules: [
                      { required: true, message: '请选择取件时间' }
                    ]
                  }]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="快递单号">
                <a-input
                  v-decorator="['express_no', {
                    normalize: this.$lodash.trim,
                    rules: [
                      { required: true, message: '请输入快递单号' }
                    ]
                  }]"
                  @change="handleExpressNoChange"
                  allow-clear
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row v-if="data.pickup_way_slug === 'post'">
            <a-col :span="8">
              <a-form-item
                :colon="false"
                :label-col="{ span: 16 }"
                :wrapper-col="{ span: 8 }"
              >
                <div class="sf-order-action-wrapper">
                  <a-button
                    type="primary"
                    html-type="button"
                    :loading="ordering"
                    @click="handleSfOrderAction"
                  >
                    {{ currentExpressNo ? '退单' : '下单' }}
                  </a-button>
                </div>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24" v-if="data.pickup_way_slug === 'self_take'">
            <a-col :span="8">
              <a-form-item label="提货人">
                <a-input
                  v-decorator="['self_take_name', {
                    normalize: this.$lodash.trim,
                    rules: [
                      { required: true, message: '请输入提货人' }
                    ]
                  }]"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="联系方式">
                <a-input
                  v-decorator="['contact_way', {
                    normalize: this.$lodash.trim,
                    rules: [
                      { required: true, message: '请输入联系方式' }
                    ]
                  }]"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="提货时间">
                <a-date-picker
                  style="width: 100%;"
                  :show-time="{ format: 'HH:mm' }"
                  format="YYYY-MM-DD HH:mm"
                  v-decorator="['delivery_time', {
                    rules: [
                      { required: true, message: '请选择提货时间' }
                    ]
                  }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findAgentPurchaseOrder } from '@/api/agent_purchase_order'
import {
  findExpressCompanyOptions,
  createAgentPurchaseOrderDelivery,
  createSfExpressOrder,
  cancelSfExpressOrder
} from '@/api/agent_purchase_order_delivery'
import { findDefaultExpressSender } from '@/api/express_sender'

export default {
  name: 'DeliverAgentPurchaseOrder',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      defaultSender: {},
      loadingExpressCompanyOptions: false,
      expressCompanyOptions: [],
      copyAddress: '',
      ordering: false,
      currentExpressCompany: '',
      currentExpressNo: '',
      submitting: false,
      form: this.$form.createForm(this, { name: 'agent_purchase_order_delivery' })
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchExpressCompanyOptions() {
      this.loadingExpressCompanyOptions = true
      findExpressCompanyOptions().then((res) => {
        this.expressCompanyOptions = res.data
        this.loadingExpressCompanyOptions = false
      })
    },

    fetchData() {
      findAgentPurchaseOrder(this.id).then((res) => {
        this.data = res.data

        this.copyAddress = res.data.receiver + ' ' + res.data.phone_number + ' ' + res.data.address_detail
        this.currentExpressCompany = res.data.express_company || ''
        this.currentExpressNo = this.$lodash.trim(res.data.express_no || '')
        this.$nextTick(() => {
          this.form.setFieldsValue({
            express_company: this.currentExpressCompany,
            express_no: this.currentExpressNo
          })
        })
        this.applyDefaultExpressSenderToForm()
      })

      this.fetchDefaultExpressSender()
    },

    fetchDefaultExpressSender() {
      findDefaultExpressSender().then((res) => {
        this.defaultSender = res.data || {}
        this.applyDefaultExpressSenderToForm()
      })
    },

    applyDefaultExpressSenderToForm() {
      if (this.data.pickup_way_slug !== 'post') {
        return
      }
      this.$nextTick(() => {
        this.form.setFieldsValue({
          sender_address: this.defaultSender.address || '',
          sender_name: this.defaultSender.contact_name || '',
          sender_phone: this.defaultSender.contact_phone || ''
        })
      })
    },

    handleExpressCompanyChange(value) {
      this.currentExpressCompany = value || ''
    },

    handleExpressNoChange(e) {
      this.currentExpressNo = (e && e.target && e.target.value) ? this.$lodash.trim(e.target.value) : ''
    },

    isShunFengCompany() {
      const expressCompany = this.currentExpressCompany || this.form.getFieldValue('express_company') || ''
      const company = this.expressCompanyOptions.find(item => item.value === expressCompany)
      const companyName = company ? company.name : ''
      const value = String(expressCompany).toLowerCase()
      return companyName === '顺丰速运' || value.includes('顺丰') || value.includes('shunfeng') || value === 'sf'
    },

    handleSfOrderAction() {
      const expressCompany = this.currentExpressCompany || this.form.getFieldValue('express_company')
      if (expressCompany === undefined || expressCompany === null || expressCompany === '') {
        this.$message.warning('请选择快递公司')
        return
      }

      if (!this.isShunFengCompany()) {
        this.$message.warning('暂未对接，请手动下单')
        return
      }

      const expressNo = this.currentExpressNo || this.form.getFieldValue('express_no') || ''
      if (expressNo) {
        this.ordering = true
        cancelSfExpressOrder({
          agent_purchase_order_id: this.id
        }).then((res) => {
          if (res.code === 0) {
            this.form.setFieldsValue({ express_no: '' })
            this.currentExpressNo = ''
            this.$message.success('退单成功')
          }
        }).finally(() => {
          this.ordering = false
        })
        return
      }

      this.form.validateFields(['express_company', 'sender_name', 'sender_phone', 'delivery_time'], (err, values) => {
        if (err) {
          return
        }
        this.ordering = true
        createSfExpressOrder({
          agent_purchase_order_id: this.id,
          express_company: values.express_company,
          sender_name: values.sender_name,
          sender_phone: values.sender_phone,
          send_start_tm: values.delivery_time ? values.delivery_time.format('YYYY-MM-DD HH:mm:ss') : ''
        }).then((res) => {
          if (res.code === 0) {
            const orderNo = (res.data && (res.data.express_no || res.data.order_no)) || ''
            this.form.setFieldsValue({
              express_no: orderNo
            })
            this.currentExpressNo = orderNo
            if (orderNo) {
              this.$message.success('下单成功')
            } else {
              this.$message.warning('下单成功，但未返回订单号')
            }
          }
        }).finally(() => {
          this.ordering = false
        })
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = Object.assign({ agent_purchase_order_id: this.id }, {
            ...values,
            delivery_time: values.delivery_time ? values.delivery_time.format('YYYY-MM-DD HH:mm:ss') : ''
          })

          createAgentPurchaseOrderDelivery(data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    },

    onCopy: function(e) {
      this.$message.success('复制成功！')
    },

    onCopyError: function(e) {
      this.$message.error('复制失败！')
    }
  }
}
</script>

<style scoped>
.sf-order-action-wrapper {
  text-align: right;
}

</style>
